import { render, staticRenderFns } from "./friendlyReminderDialog.vue?vue&type=template&id=5c8f0583&scoped=true"
import script from "./friendlyReminderDialog.vue?vue&type=script&lang=js"
export * from "./friendlyReminderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8f0583",
  null
  
)

export default component.exports